import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { MAIN_DOMAIN, API_PATH } from '@app/app.constants';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { APIService } from '@app/_services/api.service';
import { ResponseLesson } from '@app/_interfaces/responses';

@Injectable({
    providedIn: 'root'
})
export class LessonService {
    constructor(private http: HttpClient, private api: APIService) {}

    public getShortDataLesson(lessonID: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/lessons/lesson/${lessonID}/short`);
    }

    public getLessonBoxes(lessonID: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/tasks/box/${lessonID}/get/`);
    }

    public createNewLessonBox(newBox): Observable<any> {
        return this.http.post<any>(`${MAIN_DOMAIN}/api/tasks/box/create/`, newBox);
    }

    public deleteLessonBox(boxID: number): Observable<any> {
        return this.http.delete<any>(`${MAIN_DOMAIN}/api/tasks/box/manage/delete/${boxID}/`);
    }

    public updateLessonBox(box): Observable<any> {
        return this.http.patch<any>(`${MAIN_DOMAIN}/api/tasks/box/manage/update/${box.id}/`, box);
    }

    public getLessonBox(boxID: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/tasks/box/${boxID}/`);
    }

    public generateBox(boxID: number): Observable<any> {
        return this.http.post<any>(`${MAIN_DOMAIN}/api/tasks/box/generate/${boxID}/`, boxID);
    }

    public getLevels(): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/tasks/level/`);
    }

    public pingBoxesState(lessonID: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/lessons/lesson/${lessonID}/boxes-state`);
    }

    public copyLesson(copyLessonData): Observable<any> {
        return this.http.post<any>(`${MAIN_DOMAIN}/api/tasks/box/copy/`, copyLessonData);
    }

    public deleteLesson(lessonID: number): Observable<any> {
        return this.http.delete<any>(`${MAIN_DOMAIN}/api/lessons/lesson/${lessonID}/`);
    }

    pollinGetHabirintTableData(lessonId: number, intTime: number): Observable<any> {
        return interval(intTime).pipe(
            switchMap(() => this.http.get<any>(`${MAIN_DOMAIN}/api/lessons/lesson/${lessonId}/habirint_table_data/`))
        );
    }

    getHabirintTableData(lessonId: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/lessons/lesson/${lessonId}/habirint_table_data/`);
    }

    checkStudentLesson(): Observable<ResponseLesson> {
        return this.api.get(API_PATH.lessons.lesson_for_student);
    }
}
